import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[(_vm.error)?_c(VLayout,{attrs:{"row":""}},[_c(VFlex,{attrs:{"xs12":"","sm6":"","offset-sm3":""}},[_c(VAlert,{attrs:{"value":_vm.error.value,"color":"error"}},[_c(VBtn,{attrs:{"icon":""}},[_c(VIcon,{on:{"click":_vm.onDismissed}},[_vm._v("close")])],1),_vm._v(" "+_vm._s(_vm.error.message)+"\n        ")],1)],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }